module.exports = __webpack_public_path__ + "static/media/background-first-login.a0fbb26e.jpg";